import { render } from "./PartnerHospital.vue?vue&type=template&id=5eb07c92"
import script from "./PartnerHospital.vue?vue&type=script&lang=js"
export * from "./PartnerHospital.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__